<template>
    <EdsCard :draggable="true" :index="index">
        <template #title>{{section.title}}</template>
        <template #actions>
            <EdsTooltip class="action" :data="'Delete'" :position="'left'">
                <i class="icon icon-trashcan" @click="deleteSection(index)"></i>
            </EdsTooltip>
        </template>
        <template #content>
            <TextComponent class="mb-0-5" :field-name="'Title'" v-model="section.title" />
            <TextComponent class="mb-0-5" :field-name="'Description'" v-model="section.description" />
            <TextComponent class="mb-0-5" :field-name="'Description 2'" v-model="section.description2" />
            <TextComponent class="mb-0-5" :field-name="'Description 3'" v-model="section.description3" />
            <FileUploadComponent class="mb-0-5" :field-name="'Image'" :value.sync="section.image" @changeValue="setImage" />
            <FileUploadComponent class="mb-0-5" :field-name="'SVG'" :acceptType="FILE_TYPES.SVG" :value.sync="section.svg" @changeValue="setSvg" />
            <ConfirmationComponent :isOpen="isOpen" confirmName="Delete" @cancel="isOpen = false" @confirm="confirmDelete(index)">
                <div slot="header">Delete</div>
                <div slot="content">Are you sure you want to delete section {{ section.title }}?</div>
            </ConfirmationComponent>
        </template>
    </EdsCard>
</template>
<script>
import TextComponent from '@/components/base.component/TextComponent.vue';
import FileUploadComponent from '@/components/base.component/FileUploadComponent.vue';
import EdsTile from '@/components/base.component/EdsTile.vue';
import EdsCard from '@/components/base.component/EdsCard.vue';
import { FILE_TYPES } from '@/constants/assets';
import EdsTooltip from '@/components/base.component/EdsTooltip.vue';
import ConfirmationComponent from '@/components/base.component/ConfirmationComponent.vue';

export default {
    components: {
        TextComponent,
        FileUploadComponent,
        EdsTile,
        EdsTooltip,
        EdsCard,
        ConfirmationComponent
    },
    data() {
        return {
            FILE_TYPES: FILE_TYPES,
            isOpen: false
        }
    },
    props: {
        section: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        setImage(fileName, file) {
            this.section.image = fileName;
            this.readFileContent(file, 'imageContent');
        },
        setSvg(fileName, file) {
            this.section.svg = fileName;
            this.readFileContent(file, 'svgContent');
        },
        deleteSection() {
            this.isOpen = true;
        },
        readFileContent(file, fieldName) {
            const fr = new FileReader();
            fr.onload = () => {
                this.section[fieldName] = fr.result;
            };
            fr.onerror = () => console.error(fr.error);
            fr.readAsDataURL(file);
        },
        confirmDelete() {
            this.isOpen = false;
            this.$emit('deleteSection', this.index);
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';

.edit-page-section {
    display: flex;
    border: 1px solid @gray-42;
    padding: 0.5rem;

    .eds-form {
        padding: 0;
    }
}
</style>